import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isNil from 'ramda/src/isNil';
import equals from 'ramda/src/equals';
import values from 'ramda/src/values';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Input from '@components/@core/Input';
import StepBar from '@components/@core/StepBar';
import Toggle from '@components/@core/Toggle';

const CertificationUser = ({ className, userId, profile, certification, contentLevel, onComplete }) => {
    const { level, completed_at, est_complete, stats, data } = certification;
    const name = `${profile.first_name} ${profile.last_name}`;
    const estDate = isNil(est_complete) ? 'NA' : moment.utc(est_complete).local().format('MMM DD, YY');
    const isCompleted = !isNil(completed_at);
    const currentLevel = isNil(stats?.levels) ? {} : stats.levels[level];
    const { courses, quotas, habits } = currentLevel;
    const isCoursesCompleted = isNil(courses) ? true : equals(courses.total, courses.complete);
    const isQuotasCompleted = isNil(quotas) ? true : equals(quotas.total, quotas.complete);
    const habitsTotal = isNil(habits) ? 0 : habits.day.total + habits.week.total + habits.month.total;
    const habitsComplete = isNil(habits) ? 0 : habits.day.complete + habits.week.complete + habits.month.complete;
    const isHabitsCompleted = equals(habitsTotal, habitsComplete);
    const isCompletedRequirements = isCoursesCompleted && isQuotasCompleted && isHabitsCompleted;

    return (
        <div className={`cert-user ${className}`}>
            <div className="d-flex">
                <p className="d-flex-1 dsl-b22 bold">{name}</p>
                <StepBar className="d-h-end" label="" step={contentLevel} maxSteps={values(data?.levels).length} />
            </div>
            <Input disabled className="input-field" title="Title" value={data?.levels[contentLevel]?.title} />
            <Input disabled className="input-field" title="Est. to complete" value={`${Number(data?.estimated_days_to_complete || 0).toFixed(1)} days`} />
            <div className="d-h-end">
                {isCompleted ? (
                    <p className="dsl-b16">{`Completed ${moment.utc(completed_at).local().format('MMM DD, YY')}`}</p>
                ) : (
                    profile.id === userId && <Button name="COMPLETE" disabled={!isCompletedRequirements} onClick={onComplete} />
                )}
            </div>
            <Accordion className="settings-certificate pb-2" icon={null}>
                <Input disabled className="input-field" title="East Time to Complete" value={`${Number(data?.estimated_days_to_complete || 0).toFixed(1)} days`} />
                <Toggle
                    disabled
                    className="toggle-button mb-4"
                    title="Chronology Lock"
                    leftLabel="Off"
                    rightLabel="On"
                    direction="horizontal"
                    checked={data?.levels[contentLevel]?.chronology_lock || false}
                />
                <Toggle disabled className="toggle-button mb-4" title="Time Lock" leftLabel="Off" rightLabel="On" direction="horizontal" checked={data?.levels[contentLevel]?.time_lock || false} />
            </Accordion>
        </div>
    );
};

CertificationUser.propTypes = {
    className: PropTypes.string,
    userId: PropTypes.number,
    profile: PropTypes.shape({
        id: PropTypes.number,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        avatar: PropTypes.string,
    }),
    certification: PropTypes.shape({
        id: PropTypes.number,
        created_at: PropTypes.string,
        est_complete: PropTypes.string,
    }),
    onComplete: PropTypes.func,
};

CertificationUser.defaultProps = {
    className: '',
    userId: 0,
    profile: {
        id: 0,
        first_name: '',
        last_name: '',
        avatar: '',
    },
    certification: {
        id: 0,
        created_at: '',
        est_complete: '',
    },
    onComplete: () => {},
};

export default memo(CertificationUser);
